'use client'

import CalendarIcon2 from '@/components/icons/calendar-icon-2'

import KeyIcon from '@/components/icons/key'
import LinkIcon from '@/components/icons/link'
import ShieldIcon from '@/components/icons/shield-icon'
import WrenchIcon from '@/components/icons/wrench-icon'
import { cn } from '@/lib/utils'
import Link from 'next/link'
import { useSelectedLayoutSegment } from 'next/navigation'

export default function DesktopNav() {
  const activeSegment = useSelectedLayoutSegment()
  const selectedSetting = activeSegment

  return (
    <div className="col-span-3 col-start-1 hidden desktop-sm:inline-block desktop-lg:col-span-2">
      <div className="flex w-full flex-col rounded-sm border border-neutral-blue-700 bg-neutral-blue-800 p-4 font-inter">
        <p className="semibold-caps text-cap text-neutral-blue-500">ROLES</p>
        <Link
          href="/profile-manager/settings/general"
          className={cn(
            'group/1 mt-2 flex cursor-pointer items-center rounded-sm p-2 align-middle text-neutral-blue-500 hover:bg-neutral-blue-700',
            {
              'bg-neutral-blue-700 text-white': selectedSetting === 'general',
            },
          )}
        >
          <WrenchIcon
            className={cn('h-6 w-6 min-w-6 stroke-neutral-blue-500', {
              'stroke-white': selectedSetting === 'general',
            })}
          />
          <div className="ml-2 text-p-3 font-semibold underline-offset-2 transition-all duration-75">
            General
          </div>
        </Link>

        <Link
          href="/profile-manager/settings/notification-preferences"
          className={cn(
            'group/6 mt-2 flex cursor-pointer items-center rounded-sm p-2 align-middle text-neutral-blue-500 hover:bg-neutral-blue-700',
            {
              'bg-neutral-blue-700 text-white':
                selectedSetting === 'notification-preferences',
            },
          )}
        >
          <CalendarIcon2
            className={cn('h-6 w-6 min-w-6 stroke-neutral-blue-500', {
              'stroke-white': selectedSetting === 'notification-preferences',
            })}
          />
          <div className="ml-2 text-p-3 font-semibold underline-offset-2 transition-all duration-75">
            Notifications
          </div>
        </Link>

        <Link
          href="/profile-manager/settings/connected-accounts"
          className={cn(
            'group/7 mt-2 flex cursor-pointer items-center rounded-sm p-2 align-middle text-neutral-blue-500 hover:bg-neutral-blue-700',
            {
              'bg-neutral-blue-700 text-white':
                selectedSetting === 'connected-accounts',
            },
          )}
        >
          <LinkIcon
            className={cn('h-6 w-6 min-w-6 stroke-neutral-blue-500', {
              'stroke-white': selectedSetting === 'connected-accounts',
            })}
          />
          <div className="ml-2 text-p-3 font-semibold underline-offset-2 transition-all duration-75">
            Connected Accounts
          </div>
        </Link>

        <Link
          href="/profile-manager/settings/privacy"
          className={cn(
            'group/8 mt-2 flex cursor-pointer items-center rounded-sm p-2 align-middle text-neutral-blue-500 hover:bg-neutral-blue-700',
            {
              'bg-neutral-blue-700 text-white': selectedSetting === 'privacy',
            },
          )}
        >
          <ShieldIcon
            className={cn('h-6 w-6 min-w-6 stroke-neutral-blue-500', {
              'stroke-white': selectedSetting === 'privacy',
            })}
          />
          <div className="ml-2 text-p-3 font-semibold underline-offset-2 transition-all duration-75">
            Data & Privacy
          </div>
        </Link>

        <Link
          href="/profile-manager/settings/developer"
          className={cn(
            'group/9 mt-2 flex cursor-pointer items-center rounded-sm p-2 align-middle text-neutral-blue-500 hover:bg-neutral-blue-700',
            {
              'bg-neutral-blue-700 text-white': selectedSetting === 'developer',
            },
          )}
        >
          <KeyIcon
            className={cn('h-6 w-6 min-w-6 stroke-neutral-blue-500', {
              'stroke-white': selectedSetting === 'developer',
            })}
          />
          <div className="ml-2 text-p-3 font-semibold underline-offset-2 transition-all duration-75">
            Developer
          </div>
        </Link>

        {/* PROFILES */}
      </div>
    </div>
  )
}
